export default "__VITE_ASSET__DvN4OmHM__"